module.exports = require("prismjs/components/prism-c.js");